{
  "page_count": "din {n, plural, one{# pagină} other{# pagini}}"
}
